import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorbot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 2.25a.75.75 0 0 0-.75.75v2.25H7A2.75 2.75 0 0 0 4.25 8v1.26a3.25 3.25 0 0 0-3 3.24v1a3.25 3.25 0 0 0 3 3.24V18A2.75 2.75 0 0 0 7 20.75h10A2.75 2.75 0 0 0 19.75 18v-1.26a3.25 3.25 0 0 0 3-3.24v-1a3.25 3.25 0 0 0-3-3.24V8A2.75 2.75 0 0 0 17 5.25h-4.25v-1.5H14a.75.75 0 0 0 0-1.5h-2Zm0 4.5H7c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25h-5ZM2.75 12.5a1.75 1.75 0 0 1 1.5-1.732v4.464a1.75 1.75 0 0 1-1.5-1.732v-1Zm17-1.732v4.464a1.75 1.75 0 0 0 1.5-1.732v-1a1.75 1.75 0 0 0-1.5-1.732Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M9.75 11a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Zm6 0a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorbot;
